import GlobalFields from 'defs/ga/fields/global';
import { CardProps } from 'defs/ga/fields/product';
import { Start as ProgramsStart } from 'defs/ga/fields/programs';

type trackCardTrackingArgs = {
	programId: string;
	coachCardProdNm?: string;
};

export const trackCardTrackingOpen = ({ programId, coachCardProdNm }: trackCardTrackingArgs) => ({
	[GlobalFields.Event]: 'buttonClick',
	[ProgramsStart.ButtonText]: 'zur messung',
	[ProgramsStart.ProgramId]: programId,
	[CardProps.Type]: 'tracking',
	coachCardProdNm,
});

export const trackCardTrackingComplete = ({ programId, coachCardProdNm }: trackCardTrackingArgs) => ({
	[GlobalFields.Event]: 'buttonClick',
	[ProgramsStart.ButtonText]: 'messung speichern',
	[ProgramsStart.ProgramId]: programId,
	[CardProps.Type]: 'tracking',
	coachCardProdNm,
});
